/**
 * Checks if the url contains a port number
 *
 * @param {string} url - URL which needs to be checked
 */
const hasPort = (url: string) => {
  // Checks if the url starts with either http:// or https:// or //
  const urlWithoutHttp = url.split(/^(http(s)?\:)?\/\//).pop();
  if (urlWithoutHttp) {
    //Splits the string where there is '/' and '?'.
    // This is done to find the end of actual host URL
    const domain = urlWithoutHttp.split(/[\/\?]/)[0];
    return /\:(\d+)$/.test(domain);
  }
  return false;
};

export default hasPort;
